import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { XYOffset } from 'src/app/types/xyoffset';


@Component({
	selector: 'app-xyoffset-input',
	templateUrl: './xyoffset-input.component.html',
	styleUrls: ['./xyoffset-input.component.scss']
})
export class XYOffsetInputComponent implements OnInit {

	@Input() offsetX = 0;
	@Output() offsetXChange = new EventEmitter<number>();
	@Input() offsetY = 0;
	@Output() offsetYChange = new EventEmitter<number>();
	@Input() minOffsetX = -Infinity;
	@Input() maxOffsetX = Infinity;
	@Input() minOffsetY = -Infinity;
	@Input() maxOffsetY = Infinity;
	@Input() units = 'pixels';

	set value(opts: XYOffset) {
		this.offsetX = opts.x;
		this.offsetY = opts.y;
		this.ValidateOffsetX({ notify: false });
		this.ValidateOffsetY({ notify: false });
	}
	get value(): XYOffset {
		return { x: this.offsetX, y: this.offsetY };
	}
	constructor() { }

	ngOnInit() {

	}

	ValidateOffsetX(event?) {

		if (this.offsetX < this.minOffsetX) {
			this.offsetX = this.minOffsetX;
		}
		if (this.offsetX > this.maxOffsetX) {
			this.offsetX = this.maxOffsetX;
		}
		let notify = true;
		if (!!event.notify) {
			notify = event.notify;
		}
		if (notify === true) {
			this.offsetXChange.emit(this.offsetX);
		}
	}
	ValidateOffsetY(event?) {
		if (this.offsetY < this.minOffsetY) {
			this.offsetY = this.minOffsetY;
		}
		if (this.offsetY > this.maxOffsetY) {
			this.offsetY = this.maxOffsetY;
		}
		let notify = true;
		if (!!event.notify) {
			notify = event.notify;
		}
		if (notify === true) {
			this.offsetYChange.emit(this.offsetY);
		}
	}
}
